module.exports = __webpack_public_path__ + "img/img-2b19f9.png";